<template>
    <v-container class="my-5">
        <!--   Diálogo para Mostrar un mensaje al Eliminar Invitado   -->
        <v-dialog
                v-model="deleteDialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_guest')}}
                </v-card-title>
                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteGuest()"
                            :loading="loadingGuestData"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{$t('guest_management')}}</h2>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-expansion-panels popout focusable>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ $t('celular') }}
                </v-expansion-panel-header>
                <v-expansion-panel-content><br>
                <v-alert
                  text
                  prominent
                  type="error"
                  icon="mdi-alert"
                >
                  {{ $t('msg_delete_alert') }}
                </v-alert>
                  <v-flex>
                    <v-card>
                      <v-card-title>
                          <vue-phone-number-input
                                  default-country-code="MX"
                                  color="#D32F2F"
                                  valid-color="#43a047"
                                  @update="onChange"
                                  v-model="celular_nuevo"
                                  :only-countries="countries"
                                  :translations="custom_cell_phone"
                          >
                          </vue-phone-number-input>
                          <v-btn
                            color="primary"
                            :disabled="!band_cellphone"
                            @click="getGuest()"
                            >{{ $t('Buscar') }}
                          </v-btn>
                          <v-spacer></v-spacer>
                      </v-card-title>
                      <v-card-text>
                        <v-flex xs12>
                        <v-data-table
                                :headers="headers"
                                :loading="loadingGuestData"
                                :items="guest"
                                :hide-default-footer="true"
                                :footer-props="{
                                    itemsPerPageOptions: [
                                        {text: '5', value: 5},
                                        {text: '10', value: 10},
                                        {text: '25', value: 25},
                                        {text: this.$t('todos'), value: -1}
                                    ],
                                    itemsPerPageText: $t('filas_por_pagina')
                                }"
                                :no-data-text="$t('no_resultados')"
                                class="elevation-1"
                        >
                          <template v-slot:item.action="{ item }">
                              <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                              v-bind="attrs"
                                              v-on="on"
                                              medium
                                              color="red"
                                              class="mr-2"
                                              @click="deleteDialog = true, idGuestDelete = item.id"
                                      >
                                          mdi-delete
                                      </v-icon>
                                  </template>
                                  <span>{{$t('delete')}}</span>
                              </v-tooltip>
                          </template>
                        </v-data-table>
                        </v-flex>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  E-Mail
                </v-expansion-panel-header>
                <v-expansion-panel-content><br>
                <v-alert
                  text
                  prominent
                  type="error"
                  icon="mdi-alert"
                >
                  {{ $t('msg_delete_alert') }}
                </v-alert>
                  <ValidationObserver v-slot="{ invalid }" ref="observer">
                    <ValidationProvider :rules="'required|email'" v-slot="{ errors }">
                        <v-text-field
                                class="pl-3 pr-3 pt-3"
                                v-model="correo"
                                name="correo"
                                prepend-icon="mdi-email"
                                :label="$t('email')"
                                clearable
                                outlined
                                :error-messages="errors[0]"
                        >
                        </v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            :disabled="invalid"
                            @click="getGuestByEmail()"
                            >{{ $t('Buscar') }}
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-data-table
                                  :headers="headers"
                                  :loading="loadingGuestData"
                                  :items="guest"
                                  :hide-default-footer="true"
                                  :no-data-text="$t('no_resultados')"
                                  class="elevation-1"
                          >
                            <template v-slot:item.action="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                                medium
                                                color="red"
                                                class="mr-2"
                                                @click="deleteDialog = true, idGuestDelete = item.id"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <span>{{$t('delete')}}</span>
                                </v-tooltip>
                            </template>
                          </v-data-table>
                    </ValidationProvider>
                  </ValidationObserver>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import Vue from 'vue'
import { mapState } from 'vuex'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('vue-phone-number-input', VuePhoneNumberInput)

extend('required', required)
extend('email', email)

export default {
  name: 'guest_management',
  computed: {
    ...mapState(['language'])
  },
  data: () => ({
    dialog: false,
    idHouse: '',
    name: '',
    number: '',
    nameAux: '',
    numberAux: '',
    header: [],
    loadingGuestData: false,
    loading: false,
    guest: [],
    search: '',
    update: false,
    errores: [],
    errorsPhone: [],
    idUpdate: 0,
    idDirectoryDelete: 0,
    deleteDialog: false,
    dialogImageLogo: false,
    file: null,
    rules: [
      value => !value || value.type === 'application/vnd.ms-excel' || 'Archivo con formato incorrecto.'
    ],
    headers: [],
    resultLogoURL: '',
    imageFrontURL: '',
    celular_nuevo: '',
    countries: ['MX', 'US'],
    custom_cell_phone: {},
    band_cellphone: false,
    cellphone_plus_country_code: '',
    correo: '',
    idGuestDelete: 0
  }),
  beforeUpdate () {
    this.custom_cell_phone = {
      'countrySelectorLabel': this.$t('codigo_pais'),
      'phoneNumberLabel': this.$t('celular'),
      'example': this.$t('ejemplo')
    }
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'last_name'
      },
      {
        text: this.$t('celular'),
        align: 'center',
        sortable: true,
        value: 'cellNumber'
      },
      {
        text: 'E-Mail',
        align: 'left',
        sortable: true,
        value: 'email'
      }
    ]
  },
  methods: {
    onChange (data) {
      console.log(data.formattedNumber)
      this.cellphone_plus_country_code = data.formattedNumber
      if (data.isValid) {
        this.cellphone_plus_country_code = this.cellphone_plus_country_code.replace('+', '%2B')
      }
      this.band_cellphone = data.isValid
    },
    getGuest () {
      this.loadingGuestData = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/guestsForAdmin/filter?search=' + this.cellphone_plus_country_code,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.guest = response.data
          this.loadingGuestData = false
        })
        .catch(error => {
          this.loadingGuestData = false
          console.log(error)
        })
    },
    getGuestByEmail () {
      this.loadingGuestData = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/guestsForAdmin/filter?search=' + this.correo,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.guest = response.data
          this.loadingGuestData = false
        })
        .catch(error => {
          this.loadingGuestData = false
          console.log(error)
        })
    },
    deleteGuest () {
      this.loadingGuestData = true
      const config = {
        method: 'delete',
        url: ' https://residencial-services.intrare.app/user_delete_from_admin/' + this.idGuestDelete + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Guest con ID = ', this.idGuestDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_guest_deleted'))
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          this.loadingGuestData = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    clear () {
      this.loadingGuestData = false
      this.guest = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>
